import { colorsDark } from '../../themes/dark-colors';

export const collapseDarkTheme = {
  styledLinkColor: colorsDark.royalBlue[1000],
};
